var stepIndicator = {
    bindings : {
        step: '<',
        totalSteps: '<'
    },
    /**
     * @ngInject
     */
    controller : function StepIndicatorCtrl () {
        
        var ctrl = this;

        function init () {

        }

        function link () {
        }

        function onChanges (changes) {
            
        }

        this.$onInit = init;
        this.$postLink = link;
        this.$onChanges = onChanges;
    },
    templateUrl : './angular/components/step-indicator.component.html'
};